import { Customisation, LogoOption, TextOption } from '../types';

type ArtworkData = Record<
    number,
    {
        artwork: Customisation['selectedArtwork'];
        'bundle-customisation':
            | {
                  applicationMethod: Customisation['selectedMethod'];
                  applicationType: Customisation['selectedType'];
              }
            | LogoOption
            | TextOption;
        'bundle-customisation-location': Customisation['selectedPositions'];
        'locations-mirror': Customisation['selectedPositions'];
    }
>;

export const convertCustomisationToArtworkData = (customisations: Customisation[]): ArtworkData =>
    customisations.reduce((obj, c, index) => {
        obj[index + 1] = {
            artwork: c.selectedArtwork,
            'bundle-customisation': {
                applicationMethod: c.selectedMethod,
                applicationType: c.selectedType,
                ...c.selectedOptions,
            },
            'bundle-customisation-location': c.selectedPositions,
            'locations-mirror': c.selectedPositions,
        };

        return obj;
    }, {});
